module.exports = __webpack_public_path__ + "static/img/SketchPngb066839b046371e5899717360787ebd6cd1d162ae3384c80df438aa86bfc1069.45643018.png";